module.exports = __webpack_public_path__ + "img/appid2.e04b797f.png";